import { Link } from "react-router-dom";
import { motion } from "motion/react";

const cities = [
  { label: "Málaga", slug: "malaga" },
  { label: "Marbella", slug: "marbella" },
  { label: "Fuengirola", slug: "fuengirola" },
  { label: "Torremolinos", slug: "torremolinos" },
  { label: "Benalmádena", slug: "benalmadena" },
  { label: "Mijas", slug: "mijas" },
  { label: "Estepona", slug: "estepona" },
];

const ZONES_IMAGE =
  "https://storage.readdy-site.link/project_files/cf1847c3-949c-4dd2-b2c0-64bc50d47abe/b53f370a-9292-4b0a-bd96-c6786c4759a2_konyks-vollo-max.jpeg?v=88979491e112e900c96a6d073284bd41";

export default function ZonesSection() {
  return (
    <section className="bg-white py-16 md:py-24">
      <div className="max-w-container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          {/* Colonne texte */}
          <motion.div
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="font-heading font-bold text-3xl md:text-4xl text-text-primary mb-3">
              Trabajamos en toda la Costa del Sol
            </h2>
            <p className="font-body text-lg text-text-secondary mb-8 max-w-xl">
              Desde Málaga capital hasta Estepona. Instalamos y reparamos persianas, toldos y mosquiteras en toda la provincia.
            </p>

            <motion.div
              className="flex flex-wrap gap-3 md:gap-4 mb-10"
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: 0.2 }}
            >
              {cities.map((city) => (
                <Link
                  key={city.slug}
                  to={`/zonas/${city.slug}`}
                  className="inline-flex items-center px-5 py-2.5 bg-primary-light border border-border rounded-pill font-body font-semibold text-sm text-text-primary hover:bg-primary hover:text-white hover:border-primary transition-all whitespace-nowrap"
                >
                  {city.label}
                </Link>
              ))}
            </motion.div>

            <h3 className="font-heading font-bold text-xl md:text-2xl text-text-primary mb-3">
              Reparación de persianas por zona
            </h3>
            <p className="font-body text-base text-text-secondary leading-relaxed max-w-xl">
              Cubrimos toda la Costa del Sol. Si necesitas reparar persianas en{" "}
              <Link to="/zonas/marbella" className="text-primary hover:text-primary-dark font-semibold underline underline-offset-4 transition-colors">Marbella</Link>, cambiar el motor de tu persiana en{" "}
              <Link to="/zonas/fuengirola" className="text-primary hover:text-primary-dark font-semibold underline underline-offset-4 transition-colors">Fuengirola</Link>, o instalar mosquiteras nuevas en{" "}
              <Link to="/zonas/estepona" className="text-primary hover:text-primary-dark font-semibold underline underline-offset-4 transition-colors">Estepona</Link>, llegamos en 24h. Trabajamos también en{" "}
              <Link to="/zonas/torremolinos" className="text-primary hover:text-primary-dark font-semibold underline underline-offset-4 transition-colors">Torremolinos</Link>,{" "}
              <Link to="/zonas/benalmadena" className="text-primary hover:text-primary-dark font-semibold underline underline-offset-4 transition-colors">Benalmádena</Link>,{" "}
              <Link to="/zonas/mijas" className="text-primary hover:text-primary-dark font-semibold underline underline-offset-4 transition-colors">Mijas</Link> y{" "}
              <Link to="/zonas/malaga" className="text-primary hover:text-primary-dark font-semibold underline underline-offset-4 transition-colors">Málaga capital</Link>.
            </p>
          </motion.div>

          {/* Colonne image */}
          <motion.div
            className="relative rounded-2xl overflow-hidden"
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.6, delay: 0.15 }}
          >
            <div className="aspect-[4/3] w-full">
              <img
                src={ZONES_IMAGE}
                alt="Mapa de la Costa del Sol con cobertura de servicio de reparación de persianas, toldos y mosquiteras"
                className="w-full h-full object-cover rounded-2xl"
                loading="lazy"
              />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}